<div class="dashboard-tile" style="box-sizing:content-box;">
  <div class="tile-header">
    <div class="tile-header-title">{{title}}</div>
    <div *ngIf="showClose" class="tile-header-action">
      <button mat-icon-button color="primary" (click)='buttonAction()'>
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
  <div class="tile-content">
      <div [ngStyle]="{'height.px': msgHeight, 'overflow':'auto'}">
        <ng-container *ngIf="htmlMessage">
          <div [innerHtml]="htmlMessage"></div>
        </ng-container>
        <ng-container *ngIf="message">
          <div *ngFor="let msg of message" style="margin: 0 0 16px;" [innerHtml]='msg'></div>
        </ng-container>
      </div>
    <div class="tile-footer">
      <button *ngIf="showClose" mat-button color="primary" (click)="buttonAction()">{{closeLabel}}</button>
      <button *ngFor="let btn of buttons" mat-raised-button [color]="btn.color ? btn.color : 'primary'" (click)="buttonAction(btn.value)">{{btn.label}}</button>
    </div>
  </div>
</div>
